const impedimentsType = {
  MR_DiscapacidadIntelectual: 'MR-Discapacidad Intelectual',
  HI_ProblemaAudicion: 'HI-Problema de Audición',
  AUT_Autismo: 'AUT-Autismo',
  MD_ImpedimentosMultiples: 'MD-Impedimentos Múltiples',
};

export default impedimentsType;
